<!--
  ~ Copyright (C) 2023 - Potentially Ltd
  ~
  ~ Please see distribution for license.
-->
<div class="attendance-filter-container">
  <mat-card *ngIf="expanded" class="attendance-filter-settings">
    <div class="attendance-filter-settings__header">
      <span class="small">{{ 'translations.filter.attendance.name' | transloco }}</span>
      <button mat-icon-button [matMenuTriggerFor]="contextMenu" class="isBtn">
        <span>
          {{ attendanceIs ? ('translations.filter.is' | transloco) : ('translations.filter.isNot' | transloco) }}
        </span>
        <mat-icon aria-hidden="true" class="icon">expand_more</mat-icon>
      </button>
      <span class="attendance-filter-delete" (click)="deleteFilter()" (keydown.enter)="deleteFilter()">
        <svg class="svg" role="img" aria-hidden="true">
          <use ogSvgUnify="assets/sprite/sprite.svg#delete"></use>
        </svg>
      </span>
    </div>
    <div class="attendance-filter-settings__content">
      <div *ngFor="let attendance of attendances" class="attendance-filter-settings__item">
        <div
          class="attendance-filter-settings__checkmark checkmark"
          [class.is_checked]="attendance.value"
          [attr.aria-label]="
            attendance.value
              ? ('translations.global.ariaLabels.uncheckAttendanceFilter' | transloco: { attendanceName: attendance.label })
              : ('translations.global.ariaLabels.checkAttendanceFilter' | transloco: { attendanceName: attendance.label })
          "
          (click)="changeAttendance(attendance.type)"
          (keydown.enter)="deleteFilter()"
        >
          <svg class="svg" role="img" [attr.aria-label]="'translations.global.ariaLabels.icons.check' | transloco">
            <use ogSvgUnify="assets/sprite/sprite.svg#check"></use>
          </svg>
        </div>
        <span class="attendance-filter-settings__label">{{ attendance.label }}</span>
      </div>
      <div class="attendance-filter-settings__footer">
        <button mat-stroked-button class="attendance-filter-settings__btn" (click)="applyFilter()">
          {{ 'translations.global.button.apply' | transloco }}
        </button>
      </div>
    </div>
  </mat-card>
</div>
<mat-menu #contextMenu="matMenu">
  <ng-template matMenuContent>
    <button
      mat-menu-item
      (click)="setAttendanceIs()"
      tabindex="0"
      class="is-item"
      [attr.aria-label]="'translations.global.ariaLabels.attendanceIs' | transloco"
    >
      <span>
        {{ 'translations.filter.is' | transloco }}
      </span>
    </button>
    <button
      mat-menu-item
      (click)="setAttendanceIsNot()"
      tabindex="0"
      class="is-item"
      [attr.aria-label]="'translations.global.ariaLabels.attendanceIsNot' | transloco"
    >
      <span>
        {{ 'translations.filter.isNot' | transloco }}
      </span>
    </button>
  </ng-template>
</mat-menu>
